/*
 * This is the main entry point for your package.
 *
 * You can import other modules here, including external packages. When
 * bundling using rollup you can mark those modules as external and have them
 * excluded or, if they have a jsnext:main entry in their package.json (like
 * this package does), let rollup bundle them into your dist file.
 */
// *****************************
// track state (only for DEV)
// *****************************
import _state from './_state';

export function state() {
    return _state;
}
// *****************************
// render point series
// *****************************
import _init from './_init';

export function init(obj) {
    return _init(obj);
}
// *****************************
// test typeahead
// *****************************
import _typeahead from './render-typeahead';

export function typeahead() {
    return _typeahead();
}
// *****************************
// UPDATE
// *****************************
import _update from './_update';

export function update() {
    return _update();
}





